// extracted by mini-css-extract-plugin
export default {"container":"IconWithText-module__container__l6bfk","icon":"IconWithText-module__icon__IhsFs","text":"IconWithText-module__text__nJnP7"};